import { useLocation } from 'react-router';
import { TS_LIMIT } from '../../constants';

const useTrainingSetSearchParams = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const perPage = Number(searchParams.get('perPage')) || TS_LIMIT;
  const page = Number(searchParams.get('page')) || 0;
  const labelContains = searchParams.get('label__contains') || '';
  const createdAt = searchParams.get('created_at') || '';
  const updatedAt = searchParams.get('updated_at') || '';
  const trainingSetId = searchParams.get('training_set_id') || '';
  const trained = searchParams.get('trained') || '';
  const certified = searchParams.get('certified') || '';
  const document = searchParams.get('document') || '';
  const field = searchParams.get('field') || '';
  const trainingRevision = searchParams.get('training_revision') || '';
  const vendorId = searchParams.get('vendor_id') || '';
  const vendorName = searchParams.get('vendor_name') || '';

  const generateSearchParams = (dataPoolId: string) => {
    return {
      page,
      limit: perPage,
      dataPoolId,
      offSet: page * perPage,
      ...(labelContains !== '' && { search: labelContains }),
      ...(createdAt !== '' && { created_at: createdAt }),
      ...(updatedAt !== '' && { updated_at: updatedAt }),
      ...(trainingSetId !== '' && { training_set_id: trainingSetId }),
      ...(trained !== '' && { trained }),
      ...(certified !== '' && { certified }),
      ...(document !== '' && { document }),
      ...(field !== '' && { field }),
      ...(trainingRevision !== '' && { training_revision: trainingRevision }),
      ...(vendorId !== '' && { vendor_id: vendorId }),
      ...(vendorName !== '' && { vendor_name: vendorName }),
    };
  };

  return { generateSearchParams };
};

export default useTrainingSetSearchParams;
